import { Music, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 space-y-4">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold border border-primary/20">
              <Music className="w-4 h-4" />
              {t.about.badge}
            </div>
            
            <h2 className="text-4xl md:text-5xl font-serif font-bold">
              {t.about.title}
              <span className="block text-primary mt-2">{t.about.titleHighlight}</span>
            </h2>
          </div>

          {/* Biography Content */}
          <Card className="border-2 border-primary/20 hover:shadow-2xl transition-all">
            <CardContent className="p-8 md:p-12 space-y-6">
              {/* Intro Paragraph */}
              <p className="text-xl text-foreground/90 leading-relaxed font-medium">
                {t.about.intro}
              </p>

              <div className="space-y-4 text-lg text-foreground/80 leading-relaxed">
                <p>{t.about.paragraph1}</p>
                <p>{t.about.paragraph2}</p>
              </div>

              {/* Highlight Box */}
              <div className="mt-8 bg-gradient-to-br from-primary/10 to-accent/10 border-2 border-primary/30 rounded-2xl p-6">
                <div className="flex items-start gap-3">
                  <Sparkles className="w-6 h-6 text-primary shrink-0 mt-1" />
                  <p className="text-lg font-semibold text-foreground leading-relaxed">
                    {t.about.highlight}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;
